// Source of truth for lodging hotel amenity fields. Mirrors the backend
// constant in `server/google_places/lodging_amenities.py` — keep them in sync
// when adding entries.

export const HOTEL_AMENITIES = [
  { key: 'has_restaurant', label: 'Restaurant' },
  { key: 'has_breakfast', label: 'Breakfast' },
  { key: 'has_free_breakfast', label: 'Free Breakfast' },
  { key: 'has_paid_breakfast', label: 'Paid Breakfast' },
  { key: 'has_bar', label: 'Bar' },
  { key: 'has_room_service', label: 'Room Service' },
  { key: 'has_all_inclusive', label: 'All Inclusive' },
] as const

export type HotelAmenityKey = (typeof HOTEL_AMENITIES)[number]['key']

export type HotelAmenityFields = {
  [K in HotelAmenityKey]?: boolean | null
}

// URL filter param value for an amenity ('has_bar' -> 'bar').
export const amenitySlug = (key: HotelAmenityKey): string =>
  key.replace(/^has_/, '')

// Shared column metadata for the rolled-up "Hotel Amenities" chip column.
// Used by both LodgingColumnsInfo and LodgingDoorsColumnsInfo.
export const HOTEL_AMENITIES_COLUMN = {
  header: 'Hotel Amenities',
  group: 'Hotel Amenities',
  tooltipName: 'opps_hotel_amenities',
} as const
